/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  AdminObjectState,
  SignalAdminResourceApiBase
} from '../common/controller/signal-admin-resource-api';

export interface InvoiceTranslationModel {
  id: string;
  name?: string;
  description?: string;
  locale?: string;
  specifyLocale?: boolean;
  translations?: Record<string, any> | null;
  header?: string;
  footer?: string;
  logoUrl?: string;
  objectState?: AdminObjectState;
  validationWarnings?: any[];
}

export interface InvoiceTranslationPreview {
  html: string;
}

@Injectable({providedIn: 'root'})
export class InvoiceTranslationApiService extends SignalAdminResourceApiBase<InvoiceTranslationModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'invoicetranslations');
  }

  getDefaultTranslations(): Observable<Record<string, any>> {
    return this.client.request<Record<string, any>>({
      method: 'GET',
      url: this.resourceUri('invoicetranslations/defaults'),
      params: {context: null}
    });
  }

  getPreview(id: string, paymentProvider: string): Observable<InvoiceTranslationPreview> {
    const provider = ['BNP_PARIBAS', 'PAYPAL', 'PIN_PAYMENTS'].includes(paymentProvider)
      ? paymentProvider
      : 'PAYPAL';
    return this.client.request<InvoiceTranslationPreview>({
      method: 'GET',
      url: this.resourceUri(`invoicetranslations/${encodeURIComponent(id)}/preview/${provider}`),
      params: {withAdvertiser: true}
    });
  }
}
